import React, { useEffect, useState } from 'react';
import { BlogPost } from '../types';
import { fetchMarkdownContent } from '../utils/markdownUtils';

interface BlogModalProps {
  post: BlogPost;
  onClose: () => void;
}

const BlogModal: React.FC<BlogModalProps> = ({ post, onClose }) => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'auto';
    };
  }, [onClose]);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        setError('');
        const htmlContent = await fetchMarkdownContent(post.markdownFile);
        setContent(htmlContent);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load content');
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [post.markdownFile]);

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="blog-modal" onClick={handleBackdropClick}>
      <div className="blog-modal-content">
        <span className="close-modal" onClick={onClose}>
          &times;
        </span>
        {loading && (
          <div className="loading-content">
            <p>Loading...</p>
          </div>
        )}
        {error && (
          <div className="error-content">
            <p>Error: {error}</p>
          </div>
        )}
        {!loading && !error && content && (
          <>
            <div
              className="blog-post-content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
            <div className="subscribe-cta">
              <p className="subscribe-cta-lead">
                Liked this? Get the next one in your inbox.
              </p>
              <iframe
                src="https://sohailmo.substack.com/embed?transparent=1&light=1"
                width="480"
                height="320"
                style={{ border: 0, background: 'transparent' }}
                frameBorder="0"
                scrolling="no"
                title="Subscribe to Sohail's Substack"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BlogModal;